import { Builder } from '@builder.io/react';
import dynamic from 'next/dynamic';
import { Icon } from '#const';
import { getIconUrl } from '#utils';

const SingleForm = dynamic(() => import('./SingleForm'));

Builder.registerComponent(SingleForm, {
	name: 'SingleForm',
	inputs: [
		{
			name: 'form',
			friendlyName: 'Form',
			type: 'reference',
			model: 'form',
			defaultValue: {
				'@type': '@builder.io/core:Reference',
				id: 'f86c3b6d48c94d8da964dd705d15438c',
				model: 'form',
			},
		},
		{
			name: 'showFinePrint',
			friendlyName: 'Show TCPA',
			type: 'boolean',
			defaultValue: true,
			helperText: `If true will show TCPA. TCPA is REQUIRED for any forms. 
			This option allows it to be removed from the first step`,
		},
		{
			name: 'showLogos',
			friendlyName: 'Show Logos',
			type: 'boolean',
			defaultValue: true,
			helperText: 'If TCPA text is shown this is an option to show or hide logos',
		},
		{
			name: 'finePrint',
			friendlyName: 'Fine Print',
			type: 'richText',
			required: false,
			defaultValue: `<p>
				By clicking &apos;Do I Qualify&apos; and submitting my request,
				I confirm that I have read and agree to the privacy policy of
				this site and that I consent to receive emails, phone calls and/or text
				message offers and communications from Total Injury Help and its network
				of lawyers and advocates at any telephone number or email address
				provided by me, including my wireless number, if provided. I
				understand there may be a charge by my wireless carrier for such
				communications. I understand these communications may be generated using
				an autodialer and may contain pre-recorded messages and that consent
				is not required to utilize Total Injury Help services. I understand
				that this authorization overrides any previous registrations on a federal
				or state Do Not Call registry. Accurate information is required
				for a free evaluation.
				</p>`,
		},
		{
			name: 'backgroundColor',
			friendlyName: 'Background Color',
			type: 'color',
			defaultValue: 'transparent',
			helperText: 'Background color for the form wrapper',
		},
	],
	image: getIconUrl(Icon.FORM),
});
